import { LLMConfigOptions } from "@budibase/types"
import { OpenAI } from "./openai"
import { AzureOpenAI as AzureOpenAIClient } from "openai"

export class AzureOpenAI extends OpenAI {
  protected override getClient(opts: LLMConfigOptions) {
    if (!opts.apiKey) {
      throw new Error("No Azure OpenAI API key found")
    }
    if (!opts.model) {
      throw new Error("No Azure OpenAI model specified")
    }
    return new AzureOpenAIClient({
      apiKey: opts.apiKey,
      apiVersion: "2024-10-01-preview",
      baseURL: opts.baseUrl,
    })
  }
}
